<template>
  <div>
    <v-btn @click="open()">
      <v-icon color="green" class="mr-2">mdi-plus-box</v-icon>Add Employee
    </v-btn>
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Add Employee"
          icon="mdi-account-plus"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <div>
            <v-form ref="form">
              <v-text-field
                outlined
                dense
                label="Employee Name"
                v-model="form.name"
                prepend-icon="mdi-account-circle"
                :rules="rules"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                label="Contact Number"
                v-model="form.contact_no"
                prepend-icon="mdi-phone"
                :rules="rules"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                label="Address"
                v-model="form.address"
                prepend-icon="mdi-map-marker"
                :rules="rules"
              ></v-text-field>
              <div class="d-flex">
                <p>Birth Date</p>
                <input
                  type="date"
                  v-model="form.birth_date"
                  class="mt-n4 ml-2"
                />
              </div>
              <v-select
                outlined
                dense
                label="Position"
                :items="positions"
                item-text="name"
                item-value="id"
                prepend-icon="mdi-tools"
                :rules="rules"
                v-model="form.position_id"
              ></v-select>
              <v-select
                outlined
                dense
                label="Branch"
                :items="branches"
                item-text="branch_name"
                item-value="id"
                prepend-icon="mdi-source-branch"
                :rules="rules"
                v-model="form.branch_id"
              ></v-select>
              <v-text-field
                outlined
                dense
                label="Overtime Rate"
                v-model="form.overtime_rate"
                prepend-icon="mdi-hand-coin"
                :rules="rules"
              ></v-text-field>
              <div class="d-flex">
                <p>Employment Date</p>
                <input
                  type="date"
                  class="mt-n4 ml-2"
                  v-model="form.date_of_employment"
                />
              </div>
              <v-select
                outlined
                dense
                label="Employment Status"
                :items="employmentStatuses"
                item-text="text"
                item-value="value"
                prepend-icon="mdi-account-check"
                :rules="rules"
                v-model="form.employment_status"
              ></v-select>
              <p v-if="monthsEmployed >= 3" class="caption orange--text mt-n4">
                {{ monthsEmployed }} months employed — past the 3-month
                probation, due for regularization.
              </p>
              <v-text-field
                outlined
                dense
                v-if="form.employment_status === 'regular'"
                label="Monthly Salary"
                v-model="form.monthly_salary"
                prepend-icon="mdi-cash-multiple"
                type="number"
                :rules="rules"
              ></v-text-field>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit" :loading="loading">Add</v-btn>
          <v-btn @click="dialog = false"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex/dist/vuex.common.js";
import moment from "moment";
export default {
  data() {
    return {
      dialog: false,
      form: { employment_status: "probationary" },
      rules: [(value) => !!value || "Field is Required."],
      loading: false,
      employmentStatuses: [
        { text: "Probationary", value: "probationary" },
        { text: "Regular", value: "regular" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      positions: "position/positions",
      branches: "branch/branches",
    }),
    monthsEmployed() {
      if (!this.form.date_of_employment) return 0;
      return moment().diff(moment(this.form.date_of_employment), "months");
    },
  },
  methods: {
    ...mapActions({
      add_employee: "employee/add_employee",
      get_branches: "branch/get_branches",
    }),
    open() {
      // Make sure the branch list is available for the selector.
      if (this.branches.length == 0) this.get_branches();
      this.dialog = true;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        let x = await this.$confirm({
          title: "Add Employee",
          message: "Are you sure you want to add this new employee?",
          color: "primary",
          icon: "mdi-plus",
        });
        if (x) {
          this.loading = true;
          this.add_employee(this.form)
            .then(() => {
              this.$alert({
                title: "Success",
                message: "Successfully added a new employee",
                color: "success",
                icon: "mdi-check-circle",
              });
              this.loading = false;
            })
            .catch((err) =>
              this.$alert({
                title: "Error",
                message: String(err),
                color: "error",
                icon: "mdi-alert-circle",
              })
            );
        }
      } else {
        this.$alert({
          title: "Validation",
          message: "Please check some fields",
          color: "warning",
          icon: "mdi-alert",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
